/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagnodob3Inputs */

const en_signupsflagnodob3 = /** @type {(inputs: Signupsflagnodob3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No birth date`)
};

const de_signupsflagnodob3 = /** @type {(inputs: Signupsflagnodob3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Geburtsdatum`)
};

/**
* | output |
* | --- |
* | "No birth date" |
*
* @param {Signupsflagnodob3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagnodob3 = /** @type {((inputs?: Signupsflagnodob3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagnodob3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagnodob3(inputs)
	return de_signupsflagnodob3(inputs)
});
export { signupsflagnodob3 as "signupsFlagNoDob" }